module.exports = __webpack_public_path__ + "img/wall64_ua.c5718ec5.webp";